import React from 'react'

const OurPartners = () => {
    const ourpartnerobj = [
        {
            id:1,
            img:"assets/img/channel-partner/ernest.webp",
            heading:"Ernest M. Roberts",
            span:"Director (UA Washington)",
        },
        {
            id:2,
            img:"assets/img/channel-partner/fxmallen.webp",
            heading:"Fx Mallen",
            span:"Director (France)",
        },
        {
            id:3,
            img:"assets/img/channel-partner/afanwi.webp",
            heading:"Afnawi Neba",
            span:"Director (Cameroon)",
        },
        {
            id:4,
            img:"assets/img/channel-partner/smallwood.webp",
            heading:"Derreck Landon",
            span:"Director (USA)",
        },
    ]
    return (
        <>
            <section className="ptb-80 partners">
                <div className="container-fluid">
                    <div className="section-title">
                        <h2>Our Partners</h2>
                        <div className="bar"></div>
                    </div>
                    <div className="row">
                        {ourpartnerobj.map((prtrcard) => {
                            return <div className="single-team" key={prtrcard.id}>
                            <div className="team-image">
                                <img src={prtrcard.img} alt="" loading="lazy"/>
                            </div>
                            <div className="team-content">
                                <div className="team-info1">
                                    <h3>{prtrcard.heading}</h3>
                                    <span>{prtrcard.span}</span>
                                </div>
                            </div>
                        </div>
                        })}
                    </div>
                </div>
            </section>
        </>
    )
}

export default OurPartners